import {Component, OnInit} from '@angular/core';
import {EnglishLevelsComponent} from "../../shared/components/modals/english-levels/english-levels.component";
import {ModalController} from "@ionic/angular";
import {ParentService} from "../../services/mygreencountry/parent.service";
import {PreloaderService} from "../../services/preloader/preloader.service";
import {StudyHistory} from "../../types/interfaces";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {InfoComponentModal} from "../../shared/components/modals/info/info.component";
import {TranslocoService} from "@jsverse/transloco";
import {Observable} from "rxjs";
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'app-study-history',
    templateUrl: './study-history.page.html',
    styleUrls: ['./study-history.page.scss'],
})
export class StudyHistoryPage implements OnInit {
    title$: Observable<string>;
    lang = 'uk';
    public history: StudyHistory[] | null = null;
    public groupedByYear: { [p: number]: StudyHistory[] } | null = null;
    public uniqueYears: number[];
    public showCertificatesDummy: boolean = false;

    public activeTabs: { [key: number]: boolean } = {};
    activeChild$ = this.parentService.getActiveChild();
    public childId: number | undefined = undefined;

    constructor(private modalCtrl: ModalController,
                private parentService: ParentService,
                private preloaderService: PreloaderService,
                public myGcService: MyGreenCountry,
                private translocoService: TranslocoService,
                private titleService: Title
    ) {
        this.translocoService.langChanges$.subscribe(language => {
            this.lang = language;
        })

        this.title$ = this.translocoService.selectTranslate('route.history');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });
    }


    ngOnInit() {

        // this.activeChild$.subscribe({
        //     next: (child) => {
        //
        //         if (child) {
        //             this.childId = child.id;
        //
        //             this.loadHistory(child.id);
        //         }
        //
        //     }
        // })
    }

    ionViewDidEnter() {
        let child = this.activeChild$.getValue();

        if (child) {

            this.childId = child.id;

            this.loadHistory(child.id);
        }

    }


    refresh(event: any) {
        if (this.childId) {
            this.loadHistory(this.childId, event);
        }
    }


    async loadHistory(id: number, event: any = null) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.parentService.getStudentStudyHistory(id)
            .subscribe({

                next: (response) => {
                    this.history = response.history;
                    if (this.history.length === 0) {
                        this.showCertificatesDummy = true;

                    } else {
                        this.getTabsAttribute();
                        this.sortByYear();
                    }
                },

                error: (error) => {
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();
                    if (event){
                        event.target.complete();
                    }
                }

            })
    }

    async openEnglishLevelModal() {

        const modal = await this.modalCtrl.create({
            component: EnglishLevelsComponent,
            cssClass: 'auto-height',
            componentProps: {}
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }

    sortByYear() {
        if (this.history && this.history.length > 0) {
            this.groupedByYear = this.history.reduce((acc, item) => {
                if (!acc[item.year]) {
                    acc[item.year] = [];
                }
                acc[item.year].push(item);
                return acc;
            }, {} as { [key: number]: StudyHistory[] });

        }

    }

    private getTabsAttribute() {
        if (this.history && this.history.length > 0) {

            this.uniqueYears = Array.from(new Set(this.history.map(item => item.year))).sort((a, b) => b - a);

            this.uniqueYears.forEach(year => {
                this.activeTabs[year] = false;
            });
            this.activeTabs[this.uniqueYears[0]] = true;
        }
    }

    async openCertificate(url: string) {
        this.myGcService.openUrl(url)
    }

    async openModal(type: string) {
        const modal = await this.modalCtrl.create({
            component: InfoComponentModal,
            cssClass: 'auto-height',
            componentProps: {
                type: type,
            }


        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();
    }


}
